import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import { FancyDropdownMenuItem } from 'dpl/components/FancyDropdown';
import { ROOT_HOST } from 'dpl/shared/constants/urls';

import UserHeaderLoggedInBreederMenu from './UserHeaderLoggedInBreederMenu';
import UserHeaderLoggedInBuyerMenu from './UserHeaderLoggedInBuyerMenu';

/** @param {any} props */
export default function UserHeaderLoggedInDropdownContent({
  user,
  profilePath = null,
  totalNotificationsCount,
  isPublished = false,
  handleLogoutClick
}) {
  const isBreeder = user?.breeder;
  const isBuyer = user?.buyer;
  const firstName = user?.first_name;

  return (
    <>
      {firstName && (
        <p className="font-20 font-serif fw-medium default-color bb b--default pt2 pb4 ph1 mb1">
          Hi, {firstName}!
        </p>
      )}
      {isBreeder && (
        <UserHeaderLoggedInBreederMenu
          user={user}
          totalNotificationsCount={totalNotificationsCount}
          profilePath={profilePath}
          isPublished={isPublished}
        />
      )}
      {isBuyer && (
        <UserHeaderLoggedInBuyerMenu
          user={user}
          totalNotificationsCount={totalNotificationsCount}
        />
      )}
      <div className="bt b--default mv2" />
      <FancyDropdownMenuItem itemKey="logout">
        {/* New menu style should only be applied to the breeder app for now */}
        <a
          href={ROOT_HOST}
          onClick={handleLogoutClick}
          className="flex items-center gap-8 w-100 db pv2 ph4 font-16 fw-medium secondary"
        >
          <Icon
            className="tertiary"
            name="fetch-logout-web"
            height="24px"
            width="24px"
          />
          <span>Log out</span>
        </a>
      </FancyDropdownMenuItem>
    </>
  );
}

UserHeaderLoggedInDropdownContent.propTypes = {
  user: PropTypes.shape({
    first_name: PropTypes.string,
    breeder: PropTypes.bool,
    buyer: PropTypes.bool
  }).isRequired,
  profilePath: PropTypes.string,
  totalNotificationsCount: PropTypes.number.isRequired,
  isPublished: PropTypes.bool,
  handleLogoutClick: PropTypes.func.isRequired
};
